import { render, staticRenderFns } from "./AddressManageQuantity.vue?vue&type=template&id=35196945&"
import script from "./AddressManageQuantity.vue?vue&type=script&lang=js&"
export * from "./AddressManageQuantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports